@if (hasFilters()) {
  <gstar-prime-grid-filter-form
    #filters
    triggerByChanges
    [filters]="headers()"
    [sessionKey]="sessionKey()"
    (queryChange)="filterChange($event)">
    <ng-container start-toolbar-filter>
      <ng-content select="[start-toolbar]" />
    </ng-container>
    <ng-container end-toolbar-filter>
      <ng-content select="[end-toolbar]" />
    </ng-container>
  </gstar-prime-grid-filter-form>
}
<div class="d-flex flex-wrap shadow p-3 rounded-3 bg-white">
  @for (row of dataSource(); track $index) {
    <ng-container
      *ngTemplateOutlet="
        cardTemplate()!;
        context: { $implicit: row.data }
      "></ng-container>
  } @empty {
    <p class="m-3 text-center w-100">
      {{ 'taxResult.noDataMessage' | translate }}
    </p>
  }
</div>

<gstar-grid-footer
  [data]="dataSource()"
  [paginationSetting]="pagination"
  [options]="options"
  (pageChange)="pageChange($event)" />
